/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import monitoringService from 'infrastructure/serviceHandlers/Monitoring/Monitoring';
import { GetAllTransaction } from 'services/api/paymentsApi';
import {
  TTransaction,
  TTransactionList,
  TTransactionState
} from 'typings/invoiceTypes';

export const fetchInvoices = createAsyncThunk(
  'user/fetchAllInvoices',
  async (_payload, thunkAPI) => {
    try {
      const response = await GetAllTransaction();
      return response.data as TTransactionList;
    } catch (error) {
      monitoringService.captureException(error, {
        tags: {
          feature: 'fetchInvoices',
          error_type: 'api_error'
        }
      });
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialInvoicesState: TTransactionState = {
  invoices: [],
  totalCount: 0,
  isLoading: false
};

export const invoiceSlice = createSlice({
  name: 'invoices',
  initialState: initialInvoicesState,
  reducers: {
    clearInvoices: (state) => {
      state.invoices = [];
      state.totalCount = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.invoices = action.payload.items as TTransaction[];
        state.totalCount = action.payload.total_count as number;
      })
      .addCase(fetchInvoices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchInvoices.rejected, (state) => {
        state.isLoading = false;
      });
  }
});
// Action creators are generated for each case reducer function
export const { clearInvoices } = invoiceSlice.actions;

export default invoiceSlice.reducer;
